import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AtbHomeService } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { DomSanitizer } from '@angular/platform-browser';
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { environment } from '../../../../environments/environment';
import swal from "sweetalert2";
defineLocale("it", itLocale);

declare var jQuery: any;
@Component({
  selector: "app-atb-pay-payment-methods-list",
  templateUrl: "./atb-pay-payment-methods-list.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class AtbPayPaymentMethodsListComponent implements OnInit {

  paymentMethodPath;

  checkFirstPage;
  private sub: any;

  idCustomer = null
  paymentMethods: any[] = new Array();
  paymentMethodCreationPageUrl = null;
  errorMessage;

  modalRef: BsModalRef;

  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {

      if ( params['token'] == undefined  ||  params['token'] == null ||  params['token'] == "" ) {
        this.checkFirstPage = false
      } else{
        this.checkFirstPage = true
      }
    });


    if (this.checkFirstPage == true)  {

      this.sub = this.route.params.subscribe(params => {
        var token  = params['token'];
        var user = params['user'];
        var language = params['language'];
        var role = params['role'];

        localStorage.setItem("token", token);
        localStorage.setItem("user", user)
        localStorage.setItem("language", language)
        localStorage.setItem("role", role)
        this.router.navigate(['/atb-pay/payment-methods/list'])
      });

    }

    this.paymentMethodPath = 'atbpay/payment_method'
    this.getAtbPayPaymentMethods();
  }

  getAtbPayPaymentMethods() {
    this.spinner.show();

    this.atbService.getListFilter(this.paymentMethodPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.idCustomer = response.result.idCustomer
          this.paymentMethods = [...response.result.cards, ...response.result.sepas.map(sepa => ({ ...sepa, type: 'sepa' }))]
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  addPaymentMethod(template: TemplateRef<any>) {
    this.spinner.show();

    this.atbService.newObject(null, this.paymentMethodPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.paymentMethodCreationPageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.result.newPMPageUrl)
          
          this.openModal(template, 'modal-lg modal-content-iframe', null, () => { this.getAtbPayPaymentMethods(); })
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  openModal(template: TemplateRef<any>, cssClass: string = null, showEvent: () => void = null, hideEvent: () => void = null) {
    if (showEvent) {
      this.modalService.onShow.subscribe(() => {
        showEvent();
      });
    }
    if (hideEvent) {
      this.modalService.onHide.subscribe(() => {
        hideEvent();
        this.modalRef = null;
      });
    }
    this.modalRef = cssClass ?
        this.modalService.show(template, { class: cssClass }) :
        this.modalService.show(template);
  }
  
  close() {
    this.modalRef.hide();
  }

  deletePaymentMethod(paymentMethod) {
    swal({
      title: 'Conferma Cancellazione',
      text: 'Sei sicuro di voler cancellare il metodo di pagamento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Cancella',
      cancelButtonText: 'Annulla',
      focusCancel: true
    }).then(result => {
      if (result.value) {
        this.spinner.show();
        this.atbService.delete(this.paymentMethodPath + '/' + paymentMethod.idCustomerPM).subscribe(
          response => {
            if (response.outcome.success === true) {
              // swal2("Metodo di pagamento cancellato", "", "success");
              this.getAtbPayPaymentMethods();
            } else {
              this.errorMessage = 'Credenziali non valide.';
              //   swal2("Attenzione", "Credenziali non valide", "warning");
              this.spinner.hide();
            }
          },
          error => {
            //   this.logger.log("Error", error, 200);
            this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
            /*  swal2(
            "Errore",
              "Spiacente, si è verificato un errore tecnico.",
              "error"
            );*/
            this.spinner.hide();
          }
        );
      }
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/atb-pay/payment-methods-list/atb-pay-payment-methods-list.component.ts